import React from 'react';

import './Patient.avatar.uploader.scss';

export function PatientAvatarUpload({ bio, handleClick, small, hideIfNone }) {
    const echoClick = () => {
        if(!!handleClick){
            handleClick(bio);
        }
    }

    if (bio.photo) {
        return (
            <div className={`_avatarUpload ${small ? 'small' : ''}`} onClick={echoClick}>
                <div className="photo" style={{ backgroundImage: `url(${bio.photo})` }}>

                </div>
            </div>
        )
    } else {
        const content = `${(bio.firstname || '').substring(0, 1)}${(bio.lastname||'').substring(0, 1)}`.toUpperCase();
        return (
            <div className={`_avatarUpload  ${small ? 'small' : ''} ${hideIfNone ? '_hideEmpty' : ''} ${!content ? 'empty' : ''}`} onClick={echoClick}>
                <div className="_empty">
                    <span className="material-icons">
                        add_a_photo
                    </span>
                    <h2>{content}</h2>
                </div>
            </div>
        )
    }
}